export default __webpack_public_path__ + "static/Programming-7b0e35ba0c18f42662b3029d11d57241.jpg";